import React, { Component } from 'react';
import { connect } from 'react-redux';
import { insertUser } from '../../../actions/user';
import {validateEmail} from "../../../util/util";
import Logo from '../../images/logo.png';

class RegisterForm extends Component {
  
  constructor() {
    super();
    
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      email2: '',
      password: '',
      password2: '',
      showErrorMesages: false,
      emailsMatch: true,
      passwordsMatch: true,
      emailValid: true
    }
  }
  
  render() {
    return(
      <div className="register-form">
        <div className="logo">
          <img src={Logo} alt="logo" className="center-element" />
        </div>
        <h2 className="title">Pampett</h2>
        <div className="form-wrapper">
          <form onSubmit={e => this._onSubmitRegister(e)}>
            <div className="field-wrapper">
              <input
                type="text"
                className="field"
                placeholder="first name"
                name="firstName"
                value={this.state.firstName}
                onChange={e => this._onInputChange(e)} />
              {this._renderEmptyFieldMessage(this.state.firstName)}
            </div>
            <div className="field-wrapper">
              <input
                type="text"
                className="field"
                placeholder="last name"
                name="lastName"
                value={this.state.lastName}
                onChange={e => this._onInputChange(e)} />
              {this._renderEmptyFieldMessage(this.state.lastName)}
            </div>
            <div className="field-wrapper">
              <input
                type="text"
                className="field"
                placeholder="email"
                name="email"
                value={this.state.email}
                onChange={e => this._onInputChange(e)} />
              {this._renderEmailErrorMessage()}
            </div>
            <div className="field-wrapper">
              <input
                type="text"
                className="field"
                placeholder="repeat email"
                name="email2"
                value={this.state.email2}
                onChange={e => this._onInputChange(e)} />
              {this._renderRepeatEmailErrorMessage()}
            </div>
            <div className="field-wrapper">
              <input
                type="password"
                className="field"
                placeholder="password"
                name="password"
                value={this.state.password}
                onChange={e => this._onInputChange(e)} />
              {this._renderPasswordErrorMessage()}
            </div>
            <div className="field-wrapper">
              <input
                type="password"
                className="field"
                placeholder="repeat password"
                name="password2"
                value={this.state.password2}
                onChange={e => this._onInputChange(e)} />
              {this._renderRepeatPasswordErrorMessage()}
            </div>
            <div className="text-center">
              <button type="button" className="toLogInForm link-button" onClick={() => this._showLogInForm()}>Back to Login</button>
              <br />
              <button type="submit" className="registerBtn submit-button">Register</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
  
  _onInputChange(event) {
    let {name, value} = event.target;
    this.setState({[name]: value});
  }
  
  _onSubmitRegister(event) {
    event.preventDefault();
    
    let emailsMatch = this._emailsMatch();
    let emailValid = this._emailValid();
    let passwordsMatch = this._passwordsMatch();
    
    this.setState({ emailsMatch: emailsMatch, passwordsMatch: passwordsMatch, emailValid: emailValid, showErrorMesages: true });
    
    if(emailsMatch && passwordsMatch && emailValid) {
      
      let user = {};
      user.firstName = this.state.firstName.trim();
      user.lastName = this.state.lastName.trim();
      user.email = this.state.email.trim();
      user.password = this.state.password.trim();
      
      this.props.insertUser(user);
    }
  }
  
  _showLogInForm() {
    if(this.props.showLogInForm)
      this.props.showLogInForm();
  }
  
  _emailValid() {
    return validateEmail(this.state.email);
  }
  
  _emailsMatch() {
    
    let email = this.state.email.toLowerCase();
    let email2 = this.state.email2.toLowerCase();
    
    return email !== "" && email2 !== "" && (email === email2);
  }
  
  _passwordsMatch() {
    
    let password = this.state.password.toLowerCase();
    let password2 = this.state.password2.toLowerCase();
    
    return password !== "" && password2 !== "" && (password === password2);
  }
  
  // error messages
  
  _renderEmailErrorMessage() {
    
    let {email, emailsMatch, showErrorMesages} = this.state;
    
    let message = "";
    if(showErrorMesages) {
      if (email === "") message = "Required field";
      else if (!emailsMatch) message = "Emails do not match";
      else if (!validateEmail(email)) message = "Invalid email address";
    }
    return <span className="error-message">{message}</span>;
  }
  
  _renderRepeatEmailErrorMessage() {
    
    let { email2, emailsMatch, showErrorMesages } = this.state;
    
    let message = "";
    if(showErrorMesages) {
      if (email2 === "") message = "Required field";
      else if (!emailsMatch) message = "Emails do not match";
      else if (!validateEmail(email2)) message = "Invalid email address";
    }
    return <span className="error-message">{message}</span>;
  }
  
  _renderPasswordErrorMessage() {
    
    let { password, passwordsMatch, showErrorMesages } = this.state;
    
    let message = "";
    if(showErrorMesages) {
      if(password === "")  message = "Required field";
      else if(!passwordsMatch)  message = "Passwords do not match";
    }
    return <span className="error-message">{message}</span>;
  }
  
  _renderRepeatPasswordErrorMessage() {
    
    let { password2, passwordsMatch, showErrorMesages } = this.state;
    
    let message = "";
    if(showErrorMesages) {
      if(password2 === "")  message = "Required field";
      else if(!passwordsMatch)  message = "Passwords do not match";
    }
    return <span className="error-message">{message}</span>;
  }
  
  _renderEmptyFieldMessage(field) {
    
    return <span className="error-message">{(this.state.showErrorMesages && field === "") ? "Required field" : ""}</span>;
  }
}

const mapStateToProps = state => ({
  user:  state.rootReducer.user,
  loading: state.rootReducer.user.loading,
  insertSuccess: state.rootReducer.user.insertSuccess
});

export default connect(mapStateToProps, {
  insertUser
})(RegisterForm);


// WEBPACK FOOTER //
// ./src/common/components/RegisterForm/RegisterForm.js